import React from "react";
import { Link, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

import ProductApproval from "./ProductApproval";
import ProdManager from "./ProdManager";
import TeamEnquiry from "./TeamEnquiry";
import ManageLeads from "./ManageLeads";
import ManageClients from "./ManageClients";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";
import AccessDenied from "../AccessDenied";

import "./Teams.scss";

const Teams = () => {
  const { isLoading, hasRole } = useAuth();
  const location = useLocation();

  const menuItems = [
    {
      name: "Production Approvals",
      path: "/team/product-approvals",
      component: ProductApproval,
      roles: ["ROLE_PROD-MANAGER"],
    },
    {
      name: "Production Manager",
      path: "/team/prod-manager",
      component: ProdManager,
      roles: ["ROLE_PROD-MANAGER"],
    },
    {
      name: "Team Enquiry",
      path: "/team/team-enquiry",
      component: TeamEnquiry,
      roles: ["ROLE_SALES-MANAGER"],
    },
    {
      name: "Manage Leads",
      path: "/team/manage-leads",
      component: ManageLeads,
      roles: ["ROLE_SALES-MANAGER"],
    },
    {
      name: "Manage Clients",
      path: "/team/manage-clients",
      component: ManageClients,
      roles: ["ROLE_SALES-MANAGER"],
    },
  ];

  if (isLoading) return <LoadingScreen />;

  // Filter menu items the user CAN see
  const visibleItems = menuItems.filter((item) =>
    item.roles.some((r) => hasRole(r))
  );

  return (
    <div className="team-container">
      <div className="custom-menu">
        {visibleItems.map((item, index) => (
          <div
            key={index}
            className={`custom-menu-item ${
              location.pathname === item.path ? "custom-active" : ""
            }`}
          >
            <Link to={item.path} className="custom-menu-link">
              {item.name}
            </Link>
          </div>
        ))}
      </div>

      <div className="custom-team-content">
        <Routes>
          {visibleItems.map((item, index) => (
            <Route
              key={index}
              path={item.path.replace("/team", "")}
              element={<item.component />}
            />
          ))}

          <Route
            path="/"
            element={
              hasRole("ROLE_PROD-MANAGER") ? (
                <Navigate to="/team/product-approvals" replace />
              ) : hasRole("ROLE_SALES-MANAGER") ? (
                <Navigate to="/team/team-enquiry" replace />
              ) : (
                <AccessDenied />
              )
            }
          />
        </Routes>
      </div>
    </div>
  );
};

export default Teams;
